import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import { useTranslation } from 'react-i18next'

import SignIn from './screens/SignIn'

const Stack = createStackNavigator()

export const SignInStack = () => {
  const { t } = useTranslation()
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="signIn"
        component={SignIn}
        options={{ headerShown: false, title: t('ziweischool') }}
      />
    </Stack.Navigator>
  )
}
export default SignInStack
